<template>
  <nav class="navbar navbar-expand-lg navbar-sticky sticky py-3" :class="{ 'scrolled': props.isScrolled }">
    <div class="container-lg">
      <router-link class="navbar-brand logo-style" to="/" @click="$emit('homeScroll')">
        <span class="text-primary">/</span>
        <span class="text-secondary">/</span>
        <span class="text-tertiary">/</span>
        nologo studios
      </router-link>
      
      <div class="navbar-collapse collapse show">
        <ul class="navbar-nav ms-auto mb-2 mb-lg-0 align-items-center">
          <DesktopMegaMenuItem
            title="Our services"
            menu-id="whatWeDo"
            type="grouped" :services="props.groupedServices"
            view-all-link="/services"
            :active-menu-id="state.activeMenuId"
            @show-menu="showMegaMenu"
            @hide-menu="hideMegaMenu"
          />
          <DesktopMegaMenuItem
            title="Specialist Divisions"
            menu-id="specialistDivisions"
            type="simple" :services="props.specialistServices"
            view-all-link="/specialist-divisions"
            :active-menu-id="state.activeMenuId"
            @show-menu="showMegaMenu"
            @hide-menu="hideMegaMenu"
          />
          <li class="nav-item"><router-link class="nav-link" to="/about-us">About</router-link></li>
          <!-- <li class="nav-item"><router-link class="nav-link" to="/case-studies">Case Studies</router-link></li> -->
          <li class="nav-item"><router-link class="nav-link" to="/careers">Careers</router-link></li>
          
          <li class="nav-item flex justify-content-center d-flex px-1 px-md-2 py-2 text-center">
            <a href="tel:+27312660245" class="text-dark pe-3 d-inline-flex align-items-center">
              <span class="material-symbols-outlined">
                call
              </span>
            </a>
            <a href="mailto:info@nologostudios.com" class="text-dark d-inline-flex align-items-center">
              <span class="material-symbols-outlined">mail</span>
            </a>
          </li>
          <li class="nav-item">
            <router-link to="/contact" class="btn btn-primary text-white text-center py-2 px-4">
              Get in touch
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { reactive } from 'vue';
import DesktopMegaMenuItem from './DesktopMegaMenuItem.vue';

const props = defineProps({
  isScrolled: Boolean,
  groupedServices: Object,
  specialistServices: Array,
});

defineEmits(['homeScroll']);

const state = reactive({
  activeMenuId: null as string | null,
});

let hideTimeout: number;

const showMegaMenu = (menuId: string) => {
  clearTimeout(hideTimeout);
  state.activeMenuId = menuId;
};

const hideMegaMenu = () => {
  hideTimeout = window.setTimeout(() => {
    state.activeMenuId = null;
  }, 100);
};
</script>

<style scoped lang="scss">
  .navbar-nav {
    gap: 20px;
  }
</style>